export const categories = [
  {
    id: 1,
    category: "Yaxıt və maye məhsulları",
    subCategories: [
      { id: 1, name: "Motor yağı" },
      { id: 2, name: "Transmissiya yağı" },
      { id: 4, name: "Hidravlik yağ" },
      { id: 5, name: "Antifriz" },
      { id: 6, name: "Soyuducu maye" },
      { id: 7, name: "Şüşə yuyucu" },
      { id: 8, name: "Dizel təmizləyici" },
      { id: 9, name: "Motor təmizləyici" },
      { id: 10, name: "Korroziyaya qarşı sprey" },
      { id: 11, name: "Qapı menteşe sprey" },
      { id: 63, name: "Benzin oktan qaldıran" },
      { id: 64, name: "Dizel setan qaldıran" }
    ]
  },
  {
    id: 2,
    category: "Avtomobil aksesuarları",
    subCategories: [
      { id: 12, name: "Lampa" },
      { id: 13, name: "Svarovski" },
      { id: 14, name: "Farlar" },
      { id: 15, name: "LED işıqlar" },
      { id: 16, name: "Akumulator" },
      { id: 17, name: "Təkərlər" },
      { id: 18, name: "Şinlər" },
      { id: 19, name: "Döşəmələr" },
      { id: 20, name: "Oturacaq örtükləri" },
      { id: 21, name: "GPS" },
      { id: 22, name: "Kameralar" },
      { id: 23, name: "Multimedia" },
      { id: 24, name: "Şüşə qaldırıcılar" },
      { id: 25, name: "Qapı qoruyucuları" },
      { id: 26, name: "Direksiyon üzlükləri" },
      { id: 27, name: "Döşəmə paspalar" },
      { id: 28, name: "Konsol örtükləri" }
    ]
  },
  {
    id: 3,
    category: "Avtomobil hissələri / ehtiyat hissələri",
    subCategories: [
      { id: 29, name: "Hava filtiri" },
      { id: 30, name: "Yağ filtiri" },
      { id: 31, name: "Yanacaq filtiri" },
      { id: 32, name: "Disklər" },
      { id: 33, name: "Balatalar" },
      { id: 34, name: "Əyləc mayesi" },
      { id: 35, name: "Kardan mili" },
      { id: 36, name: "Əyləc pedalı" },
      { id: 37, name: "Sükan hissələri" },
      { id: 38, name: "Amortizatorlar" },
      { id: 39, name: "Yaylar" },
      { id: 40, name: "Bələdçi barlar" },
      { id: 41, name: "İnjektorlar" },
      { id: 42, name: "Yanacaq pompaları" },
      { id: 43, name: "Stop işıqları" },
      { id: 44, name: "Flaşerlər" },
      { id: 60, name: "Benzin filtiri" },
      { id: 61, name: "Salon filtiri" },
      { id: 62, name: "Transmissiya filtiri" }
    ]
  },
  {
    id: 4,
    category: "Xüsusi məhsullar / Digər",
    subCategories: [
      { id: 45, name: "Şampun" },
      { id: 46, name: "Wax" },
      { id: 47, name: "Polish" },
      { id: 48, name: "Mikrofiber dəsmallar" },
      { id: 49, name: "Bagaj örtükləri" },
      { id: 50, name: "Yük bağlayıcı kəmərlər" },
      { id: 51, name: "Dəmir yük qutuları" },
      { id: 52, name: "Avtomobil etiketləri" },
      { id: 53, name: "LED işıqlar dekoru" },
      { id: 54, name: "Spinner / ornamentlər" },
      { id: 55, name: "Oturacaq yastıqları" },
      { id: 56, name: "Masaj aksesuarları" },
      { id: 57, name: "Yanğın söndürən" },
      { id: 58, name: "Təhlükəsizlik üçbucağı" },
      { id: 59, name: "İlk yardım dəsti" }
    ]
  }
];
